import * as AppPics from 'assets/images';

function Html() {
  return (
    <div className="mainWraper">
      <div className="saved-flag changessave">
        <span className="green-check"></span>
        Changes Saved!
      </div>
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back">
              <img src={AppPics.BackSvg} alt="" />
            </button>
          </li>
          <li className="active">Course Structure</li>
        </ul>
        <div className="tab__content">
          <div className="tab__content-actHead">
            <h3>Physics</h3>
            <button className="btn-plane">AS Level</button>
            <button className="btn-plane green">AQA</button>
            <img className="country_tag" src={AppPics.UkFlagSvg} alt="" />
          </div>
          <div className="tab__content-actBody">
            <div className="px-5">
              <div className="row justify-content-end my-4 ">
                <div className="offset-10 col-md-2 col-lg-2 col-sm-12">
                  <button className="btn-plane g--tint">Add CHAPTER</button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-10 col-lg-10 col-sm-12">
                  <div className="lessonWrap lessonWrap--border formfield">
                    <label htmlFor="">Chapter Name</label>
                    <input type="text" placeholder="Test Lesson 1" />
                  </div>
                </div>
              </div>

              <div className="row mt-5 ">
                <div className="col-md-10 col-lg-10 col-sm-12">
                  <div className="lessonWrap saved lessonWrap--border bgltgreen">
                    <div className="lessonWrap__text">
                      <span className="lessonWrap__name">Test Chapter 1</span>
                      <button className="lessonWrap__btn">
                        <img src={AppPics.EditSvg} alt="" />
                      </button>
                      <button className="lessonWrap__btn">
                        <img src={AppPics.CopySvg} alt="" />
                      </button>
                      <button className="lessonWrap__btn">
                        <img src={AppPics.StampSvg} alt="" />
                      </button>
                      <button className="lessonWrap__btn">
                        <img src={AppPics.ViewStrikeSvg} alt="" />
                      </button>
                      <button className="lessonWrap__btn">
                        <img src={AppPics.DownloadSvg} alt="" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-2 col-lg-2 col-sm-12">
                  <button className="btn-plane p--tint m-l-btn">+ LESSON</button>
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-12">
                  <div className="saved lessonWrap--border p-0">
                    <div className="row bgltgreen level1">
                      <div className="col-md-10 col-lg-10 col-sm-12">
                        <div className="lessonWrap saved lessonWrap--border ">
                          <div className="lessonWrap__text">
                            <span className="lessonWrap__name">Test Chapter 1</span>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.EditSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.CopySvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.StampSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.ViewStrikeSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.DownloadSvg} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-lg-2 col-sm-12 my-auto">
                        <button className="btn-plane p--tint m-l-btn">+ LESSON</button>
                      </div>
                    </div>
                    <div className="row m-4">
                      <div className="col-md-10 col-lg-10 col-sm-12">
                        <div className="lessonWrap lessonWrap--border formfield">
                          <label htmlFor="">Lesson Name</label>
                          <input type="text" placeholder="Test Lesson 1" />
                        </div>
                      </div>
                      <div className="col-md-2 col-lg-2 col-sm-12">
                        <button className="btn-plane p--tint">++ SUB LESSON</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-12">
                  <div className="saved lessonWrap--border p-0">
                    <div className="row bgltgreen level1">
                      <div className="col-md-10 col-lg-10 col-sm-12">
                        <div className="lessonWrap saved lessonWrap--border ">
                          <div className="lessonWrap__text">
                            <span className="lessonWrap__name">Test Chapter 1</span>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.EditSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.CopySvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.StampSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.ViewStrikeSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.DownloadSvg} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-lg-2 col-sm-12 mt-2 my-auto">
                        <button className="btn-plane p--tint m-l-btn">+ LESSON</button>
                      </div>
                    </div>
                    <div className="row m-4">
                      <div className="col-md-10 col-lg-10 col-sm-12">
                        <div className="lessonWrap saved lessonWrap--border">
                          <div className="lessonWrap__text">
                            <span className="lessonWrap__name">Test Lesson 1</span>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.EditSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.CopySvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.StampSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.ViewStrikeSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.DownloadSvg} alt="" />
                            </button>
                          </div>
                        </div>
                        <div className="row mt-4">
                          <div className="offset-1 col-11">
                            <div className="lessonWrap lessonWrap--border formfield">
                              <label htmlFor="">Sub Lesson Name</label>
                              <input type="text" placeholder="Test Lesson 1" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-lg-2 col-sm-12">
                        <button className="btn-plane p--tint">++ SUB LESSON</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-12">
                  <div className="saved lessonWrap--border p-0">
                    <div className="row bgltgreen level1">
                      <div className="col-md-10 col-lg-10 col-sm-12">
                        <div className="lessonWrap saved lessonWrap--border ">
                          <div className="lessonWrap__text">
                            <span className="lessonWrap__name">Test Chapter 1</span>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.EditSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.CopySvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.StampSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.ViewStrikeSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.DownloadSvg} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-lg-2 col-sm-12 mt-2 my-auto">
                        <button className="btn-plane p--tint m-l-btn">+ LESSON</button>
                      </div>
                    </div>
                    <div className="row m-4">
                      <div className="col-md-10 col-lg-10 col-sm-12">
                        <div className="lessonWrap saved lessonWrap--border">
                          <div className="lessonWrap__text">
                            <span className="lessonWrap__name">Test Lesson 1</span>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.EditSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.CopySvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.StampSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.ViewStrikeSvg} alt="" />
                            </button>
                            <button className="lessonWrap__btn">
                              <img src={AppPics.DownloadSvg} alt="" />
                            </button>
                          </div>
                        </div>
                        <div className="row mt-4">
                          <div className="offset-1 col-11">
                            <div className="lessonWrap lessonWrap--border saved">
                              <div className="lessonWrap__text">
                                <span className="lessonWrap__name">Test Sub Lesson 1</span>
                                <button className="lessonWrap__btn">
                                  <img src={AppPics.EditSvg} alt="" />
                                </button>
                                <button className="lessonWrap__btn">
                                  <img src={AppPics.CopySvg} alt="" />
                                </button>
                                <button className="lessonWrap__btn">
                                  <img src={AppPics.StampSvg} alt="" />
                                </button>
                                <button className="lessonWrap__btn">
                                  <img src={AppPics.ViewStrikeSvg} alt="" />
                                </button>
                                <button className="lessonWrap__btn">
                                  <img src={AppPics.DownloadSvg} alt="" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 col-lg-2 col-sm-12">
                        <button className="btn-plane p--tint">++ SUB LESSON</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5 btnTab-foot mt-5">
            <button className="btn-right-content save">Save Changes</button>
          </div>

          <div
            className="modal fade uploaddialog  show"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered uploaddialog">
              <div className="modal-content p-5">
                <div className="modal-body">
                  <h2 className="mb-3">Select an IMAGE to upload</h2>
                  <p>(PNG / JPG / SVG / Animated SVG)</p>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30.605"
                        height="24.147"
                        viewBox="0 0 30.605 24.147"
                      >
                        <path
                          id="Icon_material-computer"
                          data-name="Icon material-computer"
                          d="M25.5,27.129a2.813,2.813,0,0,0,2.538-3.018l.013-15.092A2.823,2.823,0,0,0,25.5,6H5.1A2.823,2.823,0,0,0,2.55,9.018V24.111A2.823,2.823,0,0,0,5.1,27.129H0v3.018H30.605V27.129ZM5.1,9.018H25.5V24.111H5.1Z"
                          transform="translate(0 -6)"
                          fill="#fff"
                        ></path>
                      </svg>
                    </span>
                    From PC
                  </button>
                  <button type="button" className="btn btn-primary">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19.141"
                        height="19.141"
                        viewBox="0 0 19.141 19.141"
                      >
                        <path
                          id="Icon_material-photo-library"
                          data-name="Icon material-photo-library"
                          d="M22.141,16.4V4.914A1.92,1.92,0,0,0,20.227,3H8.742A1.92,1.92,0,0,0,6.828,4.914V16.4a1.92,1.92,0,0,0,1.914,1.914H20.227A1.92,1.92,0,0,0,22.141,16.4ZM11.613,12.57l1.943,2.594L16.4,11.613,20.227,16.4H8.742ZM3,6.828v13.4a1.92,1.92,0,0,0,1.914,1.914h13.4V20.227H4.914V6.828Z"
                          transform="translate(-3 -3)"
                          fill="#fff"
                        ></path>
                      </svg>
                    </span>
                    From LIBRARY
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary cancelbtn"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </div>
      </div>
    </div>
  );
}

export default Html;
